import { checkImagesUploaded } from '../Image/checkImagesUploaded';
import postForm from './postForm';
import updateFormStatus from './updateFormStatus';
import { LOCALSTATUS as localStatusList, STATUS as statusList } from '../../config';

// Write the forms file and trigger the event
export default async function storeForm(formId, status = statusList.saved) {
  await updateFormStatus(formId, localStatusList.sending, 'localStatus');
  const onlyStatus = status === 4;
  if (status) await postForm(formId, status, onlyStatus);
  if (!(await checkImagesUploaded(formId))) {
    throw new Error('form_not_saved_error_upload_images');
  }
}
